module.exports = __webpack_public_path__ + "img/home_service_response.2d0fd9ed.png";